import { render, staticRenderFns } from "./GapNotifier.vue?vue&type=template&id=a1b59e82&scoped=true&"
import script from "./GapNotifier.vue?vue&type=script&lang=ts&"
export * from "./GapNotifier.vue?vue&type=script&lang=ts&"
import style0 from "./GapNotifier.vue?vue&type=style&index=0&id=a1b59e82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1b59e82",
  null
  
)

export default component.exports